import { render } from "./ProductCardView.vue?vue&type=template&id=36d31207&scoped=true"
import script from "./ProductCardView.vue?vue&type=script&lang=js"
export * from "./ProductCardView.vue?vue&type=script&lang=js"

import "./ProductCardView.vue?vue&type=style&index=0&id=36d31207&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d31207"]])

export default __exports__